<template>
	<div class="text-justify">
		<div class="content-wrapper">
			<app-overlay-loader v-if="preloader" />
			<div class="row">
				<!-- Form -->
				<div class="col-lg-12">
					<form
						ref="consentForm"
						:data-url="'/transaction/lead/' + value.id"
						class="mb-0"
						:class="{ 'loading-opacity': preloader }"
					>
						<div class="row">
							<div class="col-lg-12">
								<div class="row">
									<!-- Consent 1 -->
									<div class="col-md-12">
										<div class="form-group row">
											<label
												for="radio_consent_1"
												class="col-lg-5"
											>
												Parent and child will follow CLC
												policy, procedures and rules
											</label>
											<div class="col-lg-7">
												<app-input
													id="radio_consent_1"
													type="radio"
													:list="yes_and_no_list"
													v-model="
														consentForm.is_parents_agree_0
													"
												/>
											</div>
										</div>
									</div>
									<!-- Consent 2 -->
									<div class="col-md-12">
										<div class="form-group row">
											<label
												for="radio_consent_2"
												class="col-lg-5"
											>
												Parent will allow child to use
												CLC Flashcards to support their
												learning
											</label>
											<div class="col-lg-7">
												<app-input
													id="radio_consent_2"
													type="radio"
													:list="yes_and_no_list"
													v-model="
														consentForm.is_parents_agree_1
													"
												/>
											</div>
										</div>
									</div>
									<!-- Consent 3 -->
									<div class="col-md-12">
										<div class="form-group row">
											<label
												for="radio_consent_3"
												class="col-lg-5"
											>
												Parent will allow and encourage
												child to use CLC App Learning
												Support every day
											</label>
											<div class="col-lg-7">
												<app-input
													id="radio_consent_3"
													type="radio"
													:list="yes_and_no_list"
													v-model="
														consentForm.is_parents_agree_2
													"
												/>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>

						<!-- Submit and Clear button -->
						<div class="mt-5 action-buttons">
							<button
								type="submit"
								class="btn btn-primary mr-2"
								:disabled="submitConsentFormDisabled"
								@click.prevent="submitConsentForm"
							>
								{{ $t("submit") }}
							</button>
							<!-- <button
								type="submit"
								class="btn btn-secondary"
								@click.prevent="clearConsentForm"
							>
								{{ $t("clear") }}
							</button> -->
						</div>
					</form>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { ConsentFormMixin } from "./ConsentFormMixin";
import GlobalHelperMixin from "../../../../../../Mixins/global/GlobalHelperMixin";

export default {
	mixins: [ConsentFormMixin, GlobalHelperMixin],
	props: {
		value: {
			type: Object,
			default: () => {
				return {
					code: "",
					name: "",
					is_active: "",
				};
			},
		},
	},
	data() {
		return {
			preloader: false,
			submitConsentFormDisabled: true,
			originalConsentForm: {},
			consentForm: {
				is_parents_agree_0: this.value.is_parents_agree_0 ?? 0,
				is_parents_agree_1: this.value.is_parents_agree_1 ?? 0,
				is_parents_agree_2: this.value.is_parents_agree_2 ?? 0,
			},
			yes_and_no_list: [
				{ id: 0, value: "No" },
				{ id: 1, value: "Yes" },
			],
		};
	},
	created() {
		this.originalConsentForm = JSON.parse(JSON.stringify(this.consentForm));
	},
	methods: {
		beforeSubmitConsentForm() {
			this.preloader = true;
		},
		submitConsentForm() {
			// Handle form submission here
			this.originalConsentForm = JSON.parse(
				JSON.stringify(this.consentForm)
			);
			this.submitConsentFormDisabled = JSON.stringify(this.consentForm) === JSON.stringify(this.originalConsentForm)
			this.saveConsentForm(this.consentForm);
		},
		afterSuccessConsentForm(res) {
			this.$toastr.s(res.data.message);
			// this.clearConsentForm();
		},
		afterFinalResponseConsentForm() {
			this.preloader = false;
			this.scrollToTop(false);
		},
		afterErrorConsentForm(res) {
			if (res === undefined) {
				return;
			} else if (res.data === undefined) {
				return;
			} else if (res.data.message === undefined) {
				return;
			} else {
				this.$toastr.e(res.data.message);
			}
		},
		clearConsentForm() {
			// Clear form fields here
			this.consentForm = {};
			// this.basicInfo.custom_file = null;
		},
	},
	watch: {
		consentForm: {
			handler: function (val) {
				// Ensure that is_parents_agree values are integers
				val.is_parents_agree_0 = parseInt(
					val.is_parents_agree_0
				);
				val.is_parents_agree_1 = parseInt(
					val.is_parents_agree_1
				);
				val.is_parents_agree_2 = parseInt(
					val.is_parents_agree_2
				);

				// Check if consentForm has changed
				const isConsentFormChanged =
					JSON.stringify(val) !==
					JSON.stringify(this.originalConsentForm);

				// Update the submitConsentFormDisabled based on the change status
				this.submitConsentFormDisabled = !isConsentFormChanged;
			},
			deep: true,
		},
	},
};
</script>

<style scoped>
.ml-40 {
	margin-left: 40px; /* You can adjust the margin value as needed */
}
.mt-8 {
	margin-top: 40px;
}
/* .form-control {
	border: 3px solid;
} */
.required-star {
	color: red;
}
</style>
